import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { invitationTemplates } from '../wizard/data';

export const TemplateGallery: React.FC = () => {
  return (
    <section id="templates" className="w-full py-20 md:py-24 bg-gradient-to-br from-white via-rose-50 to-pink-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-wedding-pink to-pink-400">
            不是制式表單，大方簡潔
          </h2>
          <p className="mt-4 text-lg text-wedding-text-body">
            不用會設計、不用挑到眼花，選一款順眼的，把名字日期填一填就好
          </p>
        </div>

        <div className="grid grid-cols-2 gap-5 md:gap-8 lg:grid-cols-3">
          {invitationTemplates.map((template) => (
            <Link key={template.id} to="/register" className="group flex flex-col">
              <div className="relative mx-auto w-full max-w-[220px]">
                <div className="relative aspect-[9/19] overflow-hidden rounded-[1.9rem] border-4 border-gray-900 bg-gray-900 ring-1 ring-black/10 shadow-lg transition-all duration-300 group-hover:-translate-y-1.5 group-hover:shadow-[0_25px_50px_-12px_rgba(190,24,93,0.35)]">
                  <img
                    src={`/template-previews/${template.style}.jpg`}
                    alt={`${template.name}邀請函範本`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top"
                  />
                  <div className="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-black/60 via-black/0 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <span className="mb-6 inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-bold text-wedding-pink shadow-lg">
                      用這款開始 <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-4 text-center">
                <h3 className="text-base font-semibold text-wedding-text-title md:text-lg">{template.name}</h3>
                <p className="mt-1 text-sm text-gray-600 line-clamp-2">{template.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
